import LEAD_SOURCE from 'App/enum/leadSource';

// The bag itself lives in App/enum/leadSource — this file only keeps it reachable through the
// Angular injector for upEventForm, upEventVisit and the contact controller. Deleting it is WEB-7618.

angular.module('upsalesApp').constant('LEAD_SOURCE', LEAD_SOURCE);
